<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">校外实训基地数据子类表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="所属实训室">
          <el-select v-model="formInline.training_room" clearable filterable placeholder="请选择所属实训室">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训设备导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle == '导出中...'"
            @click="handleExportByUrl(Object.assign({}, formInline, { export: 1 }))">{{ exportTitle }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%"
        @selection-change="handleSelectionChange(...arguments, 'id')">
        <custom-table-column prop="xxdm" label="学校代码" width="180px"></custom-table-column>
        <custom-table-column prop="sxsxjdh" label="实习实训基地号" width="180px"></custom-table-column>
        <custom-table-column prop="sxsxjdmc" label="实习实训基地名称" width="180px"></custom-table-column>
        <custom-table-column prop="ytdwmc" label="依托单位名称" width="180px"></custom-table-column>
        <custom-table-column prop="ytdwxzm" label="依托单位性质码" width="180px"></custom-table-column>
        <custom-table-column prop="dwzzjgdm" label="单位组织机构代码" width="180px"></custom-table-column>
        <custom-table-column prop="zgzgzs" label="在岗职工总数" width="180px"></custom-table-column>
        <custom-table-column prop="szqy" label="所在区域" width="180px"></custom-table-column>
        <custom-table-column prop="xxdz" label="详细地址" width="180px"></custom-table-column>
        <custom-table-column prop="jdlxrxm" label="基地联系人姓名" width="180px"></custom-table-column>
        <custom-table-column prop="lxrdh" label="联系人电话" width="180px"></custom-table-column>
        <custom-table-column prop="lxryx" label="联系人邮箱" width="180px"></custom-table-column>
        <custom-table-column prop="jdclny" label="基地成立年月" width="180px"></custom-table-column>
        <custom-table-column prop="sscym" label="所属行业码" width="180px"></custom-table-column>
        <custom-table-column prop="sscym2" label="所属产业码" width="180px"></custom-table-column>
        <custom-table-column prop="mxzy" label="面向专业" width="180px"></custom-table-column>
        <custom-table-column prop="hzkssj" label="合作开始时间" width="180px"></custom-table-column>
        <custom-table-column prop="hzjssj" label="合作结束时间" width="180px"></custom-table-column>
        <custom-table-column prop="hzxyqszm" label="合作协议签署状态码" width="180px"></custom-table-column>
        <custom-table-column prop="hzztm" label="合作状态码" width="180px"></custom-table-column>
        <custom-table-column prop="sjcjsj" label="数据采集时间" width="180px"></custom-table-column>
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row, ['created_at', 'deleted_at', 'training_room_id', 'schoolid'])"
              type="text" size="small">编辑</el-button>
            <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="学校代码" prop="xxdm">
          <el-input v-model="ruleForm.xxdm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实习实训基地号" prop="sxsxjdh">
          <el-input v-model="ruleForm.sxsxjdh" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实习实训基地名称" prop="sxsxjdmc">
          <el-input v-model="ruleForm.sxsxjdmc" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="依托单位名称" prop="ytdwmc">
          <el-input v-model="ruleForm.ytdwmc" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="依托单位性质码" prop="ytdwxzm">
          <el-input v-model="ruleForm.ytdwxzm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="单位组织机构代码" prop="dwzzjgdm">
          <el-input v-model="ruleForm.dwzzjgdm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="在岗职工总数" prop="zgzgzs">
          <el-input v-model="ruleForm.zgzgzs" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所在区域" prop="szqy">
          <el-input v-model="ruleForm.szqy" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="xxdz">
          <el-input v-model="ruleForm.xxdz" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地联系人姓名" prop="jdlxrxm">
          <el-input v-model="ruleForm.jdlxrxm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="lxrdh">
          <el-input v-model="ruleForm.lxrdh" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱" prop="lxryx">
          <el-input v-model="ruleForm.lxryx" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地成立年月" prop="jdclny">
          <el-input v-model="ruleForm.jdclny" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属行业码" prop="sscym">
          <el-input v-model="ruleForm.sscym" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属产业码" prop="sscym2">
          <el-input v-model="ruleForm.sscym2" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="面向专业" prop="mxzy">
          <el-input v-model="ruleForm.mxzy" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="合作开始时间" prop="hzkssj">
          <el-input v-model="ruleForm.hzkssj" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="合作结束时间" prop="hzjssj">
          <el-input v-model="ruleForm.hzjssj" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="合作协议签署状态码" prop="hzxyqszm">
          <el-input v-model="ruleForm.hzxyqszm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="合作状态码" prop="hzztm">
          <el-input v-model="ruleForm.hzztm" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="数据采集时间" prop="sjcjsj">
          <el-input v-model="ruleForm.sjcjsj" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
// import { mixinImport } from '@/assets/js/mixin/import';
// import { mixinOrgan } from '@/assets/js/mixin/organization';
// import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'equipmentInto',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        // device_name: '',
        // structure_1: '',
        // major: '',
        // training_room: '',
      },
      loading: false,
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      total: 40,
      users: [],
      ruleForm: {
      },
      columns: [
      ],
      rules: {
      },
      action: '',
      downloadUrl: 'template/导入模版.xlsx',
      downloadName: '导入模版.xlsx',
      btnTitle: '导入数据',
      exportUrl: '',
      exportBtnTitle: '导出',
      downloadName: '校外实训基地数据子类表列表.xlsx',
    };
  },
  components: {},
  created() {
    this.action = `${this.baseUrlt}api/device/import`;
    this.exportUrl = `${this.baseUrlt}api/sxexport/xwsxjd/list`;
  },
  mounted() {
    // this.$store.dispatch('getTarinMent');
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/sxexport/xwsxjd/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/sxexport/xwsxjd/list', 'get', params);
      if (res.code == 0) {
        if (res.data) {
          // this.tableData = [{ZJSJWYXBS:111,XXDM:222}];
          this.tableData = res.data.data;
          this.total = res.data.total;

        }
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
